export default __webpack_public_path__ + "static/media/car2.2024ea8d.jpeg";